// extracted by mini-css-extract-plugin
module.exports = {"userStoryBox":"UserStoryBox_userStoryBox__9SHSF","content":"UserStoryBox_content__eyJti","carousel":"UserStoryBox_carousel__T7kUG"};